<template>
    <!--添加资源 -->
    <div v-loading.fullscreen.lock="loading" element-loading-background="rgba(0, 0, 0, 0.2)"
        element-loading-text="正在上传中...">
        <!-- 语音资源 -->
        <div class="audio">
            <TestAudio v-if="isShowAudioPlayer" :isShowAudioPlayer="isShowAudioPlayer" :audio="audio"
                @closeAudioPlay="closeAudioPlay"></TestAudio>
        </div>
        <!-- 图片资源 -->
        <div class="work-photos">
            <div class="one-photo" v-for="(item, index) in thumb_photos" :key="index">
                <el-image :src="item" :fit="'cover'" :preview-src-list="thumb_photos" />
                <img @click="deletePhoto(index)" class="delete_img" src="@/assets/housework/delete.png" alt="">
            </div>
        </div>
        <div class="work-add-resourse">
            <el-upload action="#" :show-file-list="false" accept="audio/*" :http-request="voiceUpload"
                :on-change="audioChange">
                <img src="@/assets/housework/upload_voice.png" />
                <span style="color:#BFC4C8">添加音频</span>
            </el-upload>
            <el-upload action="#" :disabled="photo.length > 8" accept="image/png, image/jpeg, image/jpg,image/gif"
                :show-file-list="false" :limit="9" :on-change="handleChange" :http-request="imgsUpload">
                <img @click="handleClick" src="@/assets/housework/upload_photo.png" />
                <span @click="handleClick" style="color:#BFC4C8">添加图片</span>
            </el-upload>
        </div>
    </div>
</template>

<script>
import TestAudio from "./TestAudio.vue"
export default {
    components: { TestAudio },
    data () {
        return {
            // photos: [], // 上传图片
            thumb_photos: [], //缩略图
            audio: '',
            baseURL: '',
            isShowAudioPlayer: false,
            thumb: [],
            photo: [],
            audioFile: '',
            imgFile: '',
            loading: false,// 是否显示loading
        }
    },
    props: {
        hasphotos: {
            type: [Array, String],
            default: []
        },
        hasthumb: {
            type: [Array, String],
            default: () => {
                return []
            }
        },
        voice: [String]
    },

    mounted () {
        this.thumb_photos = [...this.hasthumb]
        if (this.hasphotos.length) {
            this.photo = this.deleteArea(this.hasphotos)
            this.thumb = this.deleteArea(this.hasthumb)
        }
        if (this.voice.length) {
            this.audio = this.voice
            this.isShowAudioPlayer = true
        }
    },
    methods: {
        // 去除图片前面的域名
        deleteArea (data) {
            let arr = []
            const del_str = data.length > 0 ? data[0].indexOf('uploads') : ''
            arr = data.map((item) => {
                return item.replace(del_str, '')
            })
            return arr
        },
        // 添加语音 
        audioChange (file, fileList) {
            this.loading = true
            this.audioFile = file.raw
            // this.uploadFile(file.raw, 'voice', 'voice')
        },
        // 删除语音
        closeAudioPlay () {
            this.audio = ''
            this.isShowAudioPlayer = false
            const data = {
                type: 'audio',
                audio: '',
            }
            this.$emit('addSource', data)

        },
        // 添加图片
        handleClick () {
            if (this.photo.length > 8) {
                this.$message.warning('当前最多只能上传九张图片')
            }
        },
        handleChange (file, fileList) {
            if (this.thumb_photos.length === 9) {
                this.$message.warning('最多只能上传九张图片')
                console.log("超过上限")
                return false
            }
            this.loading = true
            this.imgFile = file.raw
            // this.uploadFile(file.raw, 'img', 'homework')
        },
        // 删除图片
        deletePhoto (index) {
            this.thumb_photos.splice(index, 1)
            this.thumb.splice(index, 1)
            this.photo.splice(index, 1)
            const data = {
                type: 'img',
                thumb_photos: this.thumb,
                photos: this.photo
            }
            this.$emit('addSource', data)
        },
        // 语音上传
        voiceUpload () {
            this.uploadFile(this.audioFile, 'voice', 'voice')
        },
        // 图片上传
        imgsUpload () {
            this.uploadFile(this.imgFile, 'img', 'homework')
        },
        // 上传文件
        async uploadFile (filesrc, uri, dir) {
            let formData = new FormData()
            formData.append('file', filesrc)
            formData.append('dir', dir)
            const url = uri === 'img' ? '/base/upload/image' : '/base/upload/file'
            const { data: res } = await this.$axios.post(url, formData)
            if (res.errCode === 0) {
                if (uri === 'img') {
                    this.thumb.push(res.data.thumb)
                    this.photo.push(res.data.path)

                    this.thumb_photos.push(res.data.url)
                    const data = {
                        type: 'img',
                        thumb_photos: this.thumb,
                        photos: this.photo
                    }
                    this.$emit('addSource', data)
                    this.loading = false
                } else {
                    const voice = res.data.path
                    this.audio = res.data.url
                    this.isShowAudioPlayer = true
                    const data = {
                        type: 'audio',
                        audio: voice,
                    }
                    this.$emit('addSource', data)
                    setTimeout(() => {
                        this.loading = false
                    }, 2000)
                }


            }

        },
    },

}
</script>

<style lang="scss" scoped>
.audio {
    width: 530px;
    margin: 16px;
}

.work-photos {
    display: flex;

    .one-photo {
        position: relative;
        margin: 16px 0 16px 16px;
        width: 60px;
        height: 60px;

        .el-image {
            width: 60px;
            height: 60px;
        }

        img {
            width: 100%;
            height: 100%;
            // width: 100%;
            // margin: 16px 0 0 16px;
        }

        .delete_img {
            position: absolute;
            top: 0;
            right: 0px;
            width: 16px;
            height: 16px;

        }
    }

}

.work-add-resourse {
    display: flex;

    div {
        width: 64px;
        height: 64px;
        border-radius: 4px;
        font-size: 10px;
        color: #BFC4C8;
        text-align: center;
        background: #F5F7F8;
        margin-left: 16px;
        margin: 0 0 16px 16px;

        >>>.el-upload {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 12px;

        }

    }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/UploadFile.vue